"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _ComponentStepper_vertical_accessor_storage, _ComponentStepper_linearProgression_accessor_storage, _ComponentStepper_selectedIndex_accessor_storage, _ComponentStepper_steps_accessor_storage, _ComponentStepper_direction_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentStepper = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
let ComponentStepper = class ComponentStepper extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _ComponentStepper_vertical_accessor_storage.set(this, true);
        _ComponentStepper_linearProgression_accessor_storage.set(this, false);
        _ComponentStepper_selectedIndex_accessor_storage.set(this, 0);
        _ComponentStepper_steps_accessor_storage.set(this, []);
        _ComponentStepper_direction_accessor_storage.set(this, 'left');
    }
    get vertical() { return __classPrivateFieldGet(this, _ComponentStepper_vertical_accessor_storage, "f"); }
    set vertical(value) { __classPrivateFieldSet(this, _ComponentStepper_vertical_accessor_storage, value, "f"); }
    get linearProgression() { return __classPrivateFieldGet(this, _ComponentStepper_linearProgression_accessor_storage, "f"); }
    set linearProgression(value) { __classPrivateFieldSet(this, _ComponentStepper_linearProgression_accessor_storage, value, "f"); }
    get selectedIndex() { return __classPrivateFieldGet(this, _ComponentStepper_selectedIndex_accessor_storage, "f"); }
    set selectedIndex(value) { __classPrivateFieldSet(this, _ComponentStepper_selectedIndex_accessor_storage, value, "f"); }
    get steps() { return __classPrivateFieldGet(this, _ComponentStepper_steps_accessor_storage, "f"); }
    set steps(value) { __classPrivateFieldSet(this, _ComponentStepper_steps_accessor_storage, value, "f"); }
    get direction() { return __classPrivateFieldGet(this, _ComponentStepper_direction_accessor_storage, "f"); }
    set direction(value) { __classPrivateFieldSet(this, _ComponentStepper_direction_accessor_storage, value, "f"); }
    onStepSelect(event) {
        const onStepSelect = new CustomEvent('onStepSelect', {
            bubbles: true,
            composed: true,
            detail: event.detail,
        });
        this.dispatchEvent(onStepSelect);
        this.requestUpdate();
    }
    render() {
        return (0, lit_1.html) `
        ${this.vertical ? (0, lit_1.html) `
          <forge-drawer direction=${this.direction}>
            <aside>
              <forge-stepper .linear=${this.linearProgression} .selectedIndex="${this.selectedIndex}" .vertical="${this.vertical}" .steps=${this.steps} @forge-step-select=${this.onStepSelect} ></forge-stepper>
            </aside>
          </forge-drawer>
        ` : (0, lit_1.html) `<forge-stepper .linear=${this.linearProgression} .selectedIndex="${this.selectedIndex}" .vertical="${this.vertical}" .steps=${this.steps} @forge-step-select=${this.onStepSelect} ></forge-stepper>`}
    `;
    }
};
exports.ComponentStepper = ComponentStepper;
_ComponentStepper_vertical_accessor_storage = new WeakMap();
_ComponentStepper_linearProgression_accessor_storage = new WeakMap();
_ComponentStepper_selectedIndex_accessor_storage = new WeakMap();
_ComponentStepper_steps_accessor_storage = new WeakMap();
_ComponentStepper_direction_accessor_storage = new WeakMap();
Object.defineProperty(ComponentStepper, "styles", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: []
});
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], ComponentStepper.prototype, "vertical", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], ComponentStepper.prototype, "linearProgression", null);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], ComponentStepper.prototype, "selectedIndex", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], ComponentStepper.prototype, "steps", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentStepper.prototype, "direction", null);
exports.ComponentStepper = ComponentStepper = __decorate([
    (0, decorators_js_1.customElement)('sup-component-stepper')
], ComponentStepper);
